const InfoCasasBrand = require("./InfoCasasBrand");
const CasasEnElEsteBrand = require("./CasasEnElEsteBrand");

const getBranding = appTheme => {
	switch (appTheme) {
		case "casaseneleste":
			return CasasEnElEsteBrand;
		case "infocasas":
			return InfoCasasBrand;
		default:
			return InfoCasasBrand;
	}
};

module.exports = { getBranding };
